import { Badge, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AlertTypeBadge from "../alerts/AlertTypeBadge";

const NotificationCenter = ({ count = 0, items = [] }) => {
  const [anchor, setAnchor] = useState(null);
  const { t } = useTranslation();
  return (
    <>
      <IconButton aria-label={t("topbar.notifications")} onClick={(event) => setAnchor(event.currentTarget)} sx={{ width: 36, height: 36 }}>
        <Badge color="error" badgeContent={count} max={9}><NotificationsOutlinedIcon /></Badge>
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} PaperProps={{ sx: { width: 340, maxWidth: "calc(100vw - 32px)", "& .MuiMenuItem-root": { whiteSpace: "normal" } } }}>
        {(items.length ? items : [{ id: "empty", title: t("platform.notifications.emptyTitle"), detail: t("platform.notifications.emptyDetail") }]).slice(0, 5).map((item) => (
          <MenuItem key={item.id} onClick={() => setAnchor(null)}>
            <Stack>
              {item.detectionType ? <AlertTypeBadge type={item.detectionType} label={item.title} /> : <Typography fontWeight={600}>{item.title}</Typography>}
              <Typography variant="caption" color="text.secondary">{item.detail}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default NotificationCenter;
